// React 
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import SVGsprite from './svgSprite';

//SCSS
import '../../scss/components/main/footer.scss';
import FooterMenu from './menus/FooterMenu';
import { isIterableArray } from '../block-slider/utils';
import FooterMenuMobile from './menus/FooterMenuMobile';
import { MenuImages } from './menus/linkUtils';

import logo from '../../img/logo-new.svg';
import { STORE_NAME } from '../../linkConfig';

export default function Footer(props) {

    const { headerData, footerData, handleClick } = props


    return (
        <>
            <footer className='footer'>
                <Container>


                    <FooterMenu
                        headerData={headerData}
                        footerData={footerData}
                    />

                    <FooterMenuMobile
                        footerData={footerData}
                        headerData={headerData}
                    />


                    <div className="footer__bottom">

                        <div className="footer__bottom-main">
                            <Link to="/">
                                <img src={logo} alt={STORE_NAME} />
                            </Link>
                            <p className="copyright">{footerData?.type8?.text_copyright}</p>
                        </div>

                        <div className="footer__bottom-blocks">
                            {
                                isIterableArray(footerData?.type7) &&
                                <MenuImages items={footerData?.type7} />
                            }
                        </div>

                    </div>
                </Container>
            </footer>
            <div id='overlay_main' > {handleClick}</div >
            <SVGsprite />
        </>
    )
}